import axios from 'axios'
import qs from 'qs'
let origin = window.$envConfig && window.$envConfig.scannerApiMainDomain ? window.$envConfig.scannerApiMainDomain : window.location.origin
axios.defaults.baseURL = origin
export const getArticle = (url, params, success, error) => {
  axios.post(url, qs.stringify(params)).then((res) => {
    success(res)
  }).catch(err => {
    error(err)
  })
}


// WEBPACK FOOTER //
// ./src/views/rich-privacypolicy/http.js